import React, { useEffect, useState } from "react";
import { isMobileScreen } from "@/utils/functions";

export default function Video({
  src,
  srcDesk,
  srcMob,
  posterSrcDesk,
  posterSrcMob,
  className,
}) {
  const [isMobile, setIsMobile] = useState(null);

  useEffect(() => {
    setIsMobile(isMobileScreen);
  }, []);

  return (
    <>
      <video
        width="100%"
        height="100%"
        src={`${src ? src : !isMobile ? srcDesk : srcMob}`}
        poster={`${!isMobile ? posterSrcDesk : posterSrcMob}`}
        muted
        autoPlay
        loop
        typeof="video/mp4"
        className={`video ${className}`}
        loading="lazy"
        playsInline
      ></video>
      <style jsx>{`
        .video {
          border-radius: 16px;
          object-fit: cover;
        }
      `}</style>
    </>
  );
}
